<template>
  <div class="container">
    <CreateButton
      v-if="canEdit"
      icon-name="iconbianji"
      :text="`${$t(`okr.titles.input`)}${$t(`okr.titles.${isPerformanceLeader?'leaderTitle':'normalTitle'}`)}`"
      :style="{ backgroundColor: '#F8F9FF' }"
      @click="$emit('create-objective')"
    />
    <!-- <a-empty
      v-else
      :image="require('@/assets/images/empty-okr-list.png')"
      :image-style="{
        height: '30%'
      }"
      class="empty-okr-list"
    /> -->
    <div v-else>
      {{ $t('shared.noData') }}
    </div>
  </div>
</template>

<script>
import CreateButton from '@/components/CreateButton'

export default {
  components: {
    CreateButton
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true
    },
    isPerformanceLeader: {
      type: Boolean,
      default: false
    }
  },
  emits: ['create-objective']
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: calc(20vh);
  background: #fff;
  box-shadow: 0 0 6px 0 rgba(39, 52, 125, 0.08);
  border-radius: 8px;
  margin: 0;
}
</style>
